export default __webpack_public_path__ + "static/media/cable.f5252a68.svg";